// 着地点（期待する対応・AI が選んだ対応）の画面での呼び名。
// 督促チャットの判断記録と AIドラフト検証の画面の両方で使うので、どちらの機能にも閉じない場所に置く

/**
 * 期待する対応を決めずに試すケースの目印（API の値。画面には出さず「未定」と出す）。
 * プロンプトの比較の「期待どおり」の数に入れず、回帰テストに入れられない（API でも弾く）
 */
export const UNSET_TERMINAL = "UNSET"
export const UNSET_SHORT_NAME = "試すだけ"
export const UNSET_LABEL = `未定（${UNSET_SHORT_NAME}）`
export const isUnsetTerminal = (terminal: string | null | undefined) => terminal === UNSET_TERMINAL

/** 1文字の記号でない対応の、画面に出す短い呼び名（内部コードを画面に出さない） */
const TERMINAL_SHORT_LABELS: Record<string, string> = {
  A_PLUS: "A+",
  B_PLUS: "B+",
  CALL: "電話後",
  PARTIAL_CHECK: "一部入金の確認",
  EMP_MISSING: "就業の聴取",
  HUMAN_FOLLOW: "人の対応推奨",
  HUMAN_REVIEW: "人手対応",
  NOT_APPLICABLE: "該当なし",
  UNDETERMINED: "判断できず",
  [UNSET_TERMINAL]: "未定",
}

// AI が出した着地点をそのまま受けるので、__proto__ や constructor 等の継承したプロパティは引かない
export const terminalShortLabel = (id: string) =>
  Object.hasOwn(TERMINAL_SHORT_LABELS, id) ? TERMINAL_SHORT_LABELS[id] : id
